module.exports = __webpack_public_path__ + "img/FR11706.8515db6f.svg";